import * as React from 'react';

function SvgChevronsLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 9 16" width="1em" {...props}>
      <path
        d="M.78 7.306L7.221.616A.822.822 0 018.384.593l.022.022a.887.887 0 010 1.231L2.481 8l5.926 6.154a.886.886 0 010 1.23.822.822 0 01-1.163.023l-.022-.022L.78 8.694a1 1 0 010-1.388z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgChevronsLeft;
